import { axiosInstance } from '@/http-common'

/**
 * Create a new asset notification rule
 * @param data - Rule data
 */
export async function createAssetNotificationRule(data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/api/v1/asset-notification-rule', data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Update an existing asset notification rule
 * @param id - Rule ID
 * @param data - Updated rule data
 */
export async function updateAssetNotificationRule(id: number | string, data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset-notification-rule/${id}`, data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Permanently delete an asset notification rule
 * @param id - Rule ID
 */
export async function deleteAssetNotificationRule(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset-notification-rule/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
